import * as React from "react";
import { connect } from "react-redux";
import Select from "../common/input/select";
import DataComponent from "../common/DataComponent";
import GenericInput from "../common/input/GenericInput";
import DatePicker from "../common/DatePicker";
import SSN from "../common/input/SSNInput";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import * as types from "../../constants/actionTypes";
import Spinner from "../common/spinner";
import YesNoModal from "../common/YesNoComponent";
import ConfirmationModal from '../common/ConfirmationModal';
import InfoModal from "../common/InfoModal";
import { Redirect } from 'react-router-dom';
import SuccessBanner from './SuccessBanner';
import TryAgainToolTip from '../common/TryAgainToolTip';
import { Modal, ModalBody, Tooltip } from 'reactstrap';
import AutocompleteInput from "../common/input/AutocompleteInput";

class InsurancePlan extends DataComponent {
    constructor(props) {
        super(props);
        this.state = {
            inInputMode: props.openInsurance ? true : false,
            selectedInsurancePlan: "",
            fields: {
                dob: "",
                memberId: "",
                ssn: ""
            },
            showToolTip: false,
            showActivePlanToolTipIndex: null,
            showModal: false,
            modalText: null,
            modalYesFunction: null,
            modalNoFunction: null,
            submitEnabled: false,
            showError: false,
            makeMemberIdEmpty: false,
            showInfoModal: false,
            keyword: "",
            keywordItems: this.getUnlinkedInsurancePlans(),
            keywordLoading: false,
            keywordNoResults: false,
            refresh: false
        };
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.handleLinkAccounts = this.handleLinkAccounts.bind(this);
        this.isFromMobile = false;
        this.totalHealthPlanAccounts = props.serverData.enableNewHealthPlan ? 5 : 4;
        this.onKeywordSelected = this.onKeywordSelected.bind(this);
        this.refreshHealthPlans = this.refreshHealthPlans.bind(this);
    }

    componentDidMount() {
        this.isFromMobile = this.isMobileQueryValue || Tools.getItemFromSessionStorage('isMobile') || this.props.MobileOnQueryString;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { inInputMode } = this.state;
        if (inInputMode) {
            if ((prevProps.aal !== this.props.aal) ||
                (prevProps.linkHP && prevProps.linkHP.success !== this.props.linkHP.success) ||
                (prevProps.unlinkHP && prevProps.unlinkHP.success !== this.props.unlinkHP.success) ||
                (prevProps.linkDart && prevProps.linkDart.success !== this.props.linkDart.success) ||
                (prevProps.unlinkDart && prevProps.unlinkDart.success !== this.props.unlinkDart.success) ||
                (prevProps.linkWaco && prevProps.linkWaco.success !== this.props.linkWaco.success) ||
                (prevProps.unlinkWaco && prevProps.unlinkWaco.success !== this.props.unlinkWaco.success) ||
                (!prevProps.linkAASuccess && this.props.linkAASuccess) ||
                (!prevProps.unLinkAASuccess && this.props.unLinkAASuccess) ||
                (prevProps.linkFirstCare && prevProps.linkFirstCare.success !== this.props.linkFirstCare.success) ||
                (prevProps.unlinkFirstCare && prevProps.unlinkFirstCare.success !== this.props.unlinkFirstCare.success)) {
                this.setState({ inInputMode: false, showError: false });  // turn off the edit if an account was just delinked or linked
            }
        }
        if (prevProps.countOfLinkAAError === 2 && this.props.countOfLinkAAError === 3) {
            this.props.resetCountOfLinkAAError();
        }
        if (prevProps.hasDART !== this.props.hasDART || prevProps.hasWACO !== this.props.hasWACO) {
            this.setState({ inInputMode: false, showError: false, refresh: true }, () => {
                this.refreshHealthPlans();
            });
        }
    }

    componentWillUnmount() {
        if (!this.isFromMobile)
            this.clearAllMessages();
    }

    inputsChanged() {
        const { submitEnabled } = this.state;
        const isFormValid = this.validateInputs();
        this.setState({ showError: false });
        if (isFormValid && !submitEnabled) {
            this.setState({ submitEnabled: true });
        }
        else if (!isFormValid && submitEnabled) {
            this.setState({ submitEnabled: false });
        }
        if (this.state.fields.memberId) {
            this.setState({
                makeMemberIdEmpty: false
            })
        }
    }

    getUnlinkedInsurancePlans = () => {
        const plans = [];
        const { hasHealthPlanLogin, aal, aalDown, swhpDown, serverData, hasFirstCare, hasDART, hasWACO } = this.props;
        if (!hasHealthPlanLogin && !swhpDown) {
            plans.push({ id: "sw", label: "Baylor Scott & White Health Plan", category: "sw" });
        }
        if (!aal && !aalDown) {
            plans.push({ id: "aal", label: "BSWQA - DFW ConnectedCare", category: "aal" });
        }
        if (serverData.enableNewHealthPlan && !hasFirstCare) {
            plans.push({ id: "firstCare", label: "FirstCare Health Plans", category: "firstCare" });
        }
        if (!hasDART) {
            plans.push({ id: "dart", label: "DART", category: "dart" });
        }
        if (!hasWACO) {
            plans.push({ id: "waco", label: "City of Waco", category: "waco" });
        }
        return plans;
    }


    validateInputs = () => {
        const { selectedInsurancePlan, fields } = this.state;
        const { memberId, dob, ssn } = fields;
        const isSSNValid = /^\d{3}-\d{2}-\d{4}$/.test(ssn);
        const isMemberIdRequired = !(selectedInsurancePlan === "waco" || selectedInsurancePlan === "dart");
        const isMemberIdValid = memberId ? memberId.length >= 4 : false;
        if (!Tools.isValidDate(dob))
            return false;
        if (Tools.isEmptyString(memberId) && Tools.isEmptyString(ssn) && isMemberIdRequired)
            return false;
        if (selectedInsurancePlan === "sw" || selectedInsurancePlan === "firstCare") {
            return Tools.isValidDate(dob) && isMemberIdValid;
        } else {
            return Tools.isValidDate(dob) && (isSSNValid || (isMemberIdValid || !isMemberIdRequired));
        }
    }

    handleLinkAccounts() {
        const { memberId, ssn } = this.state.fields;
        const message = memberId || ssn;
        if (this.validateInputs()) {
            this.setState({
                showModal: true,
                modalText: "Are you sure you want to link " + message + "?",
                modalYesFunction: this.linkAccountClick,
                modalNoFunction: this.cancelModal
            });
        }
    }

    linkAccountClick = () => {
        const { selectedInsurancePlan, fields } = this.state;
        const { dob, ssn } = fields;
        let { memberId } = fields;
        const { linkAAAccount, linkHealthPlanAccount, linkFirstCareAccount, linkDartAccount, linkWacoAccount } = this.props;
        memberId = memberId.trim();
        this.setState({ showError: true });
        this.cancelModal();
        if (selectedInsurancePlan === "sw") // Health Plan Selected
        {
            logUI("MBHWeb.Account.HealthPlan.Link", new Date(), Tools.getURLPath());
            linkHealthPlanAccount(Tools.dateStringFormat(dob, "YYYY-MM-DD"), ssn.replace(/-/g, ""), memberId, this.isFromMobile);
        }
        else if (selectedInsurancePlan === "aal") // ConnectedCare Selected
        {
            logUI("MBHWeb.UI.Account.AA.Link.Clicked", new Date(), Tools.getURLPath());
            linkAAAccount(Tools.dateStringFormat(dob, "YYYY-MM-DD"), ssn.replace(/-/g, ""), memberId, this.isFromMobile);
        }
        else if (selectedInsurancePlan === "firstCare") { // FirstCare Selected
            logUI("MBHWeb.UI.Account.FirstCare.Link.Clicked", new Date(), Tools.getURLPath(), { memberId, isFromMobile: this.isFromMobile });
            linkFirstCareAccount(Tools.dateStringFormat(dob, "YYYY-MM-DD"), memberId, this.isFromMobile);
        }
        else if (selectedInsurancePlan === "dart") { //dart Selected
            logUI("MBHWeb.UI.Account.Dart.Link.Clicked", new Date(), Tools.getURLPath(), { dob, isFromMobile: this.isFromMobile });
            linkDartAccount(Tools.dateStringFormat(dob, "YYYY-MM-DD"));

        }
        else if (selectedInsurancePlan === "waco") { //waco Selected
            logUI("MBHWeb.UI.Account.Waco.Link.Clicked", new Date(), Tools.getURLPath(), { dob, isFromMobile: this.isFromMobile });
            linkWacoAccount(Tools.dateStringFormat(dob, "YYYY-MM-DD"));

        }
    }

    // Refresh Plans
    refreshHealthPlans() {
        const { refresh } = this.state;
        if (refresh) {
            const items = this.getUnlinkedInsurancePlans();
            this.setState({ refresh: false, keyword: "", keywordItems: items, keywordLoading: false, keywordNoResults: !(items.length > 0) });
        }
    }

    cancelModal = () => {
        this.setState({ showModal: false, showInfoModal: false });
    }

    toggleInputMode = () => {
        const { inInputMode } = this.state;
        if (!inInputMode) {
            this.setState({
                selectedInsurancePlan: "",
                fields: {
                    dob: "",
                    memberId: "",
                    ssn: ""
                }
            });
        }

        this.setState({
            inInputMode: !inInputMode,
            showError: false,
            submitEnabled: false,
            keyword: "",
            keywordItems: this.getUnlinkedInsurancePlans()
        });
        this.clearAllMessages();
    }

    clearAllMessages = () => {
        const { clearAALinkMessages, clearAAUnLinkMessages, clearHealthPlanLinkMessages, clearHealthPlanUnLinkMessages } = this.props;
        clearAALinkMessages();
        clearAAUnLinkMessages();
        clearHealthPlanLinkMessages();
        clearHealthPlanUnLinkMessages();
    }



    toggleTooltip() {
        this.setState(prevState => ({
            showToolTip: !prevState.showToolTip
        }));
    }

    getSuccessMessage() {
        const { unlinkDart, unlinkWaco, unlinkHP } = this.props;
        let successMessage = "";
        if (unlinkDart && unlinkDart.success) {
            successMessage = unlinkDart.successMessage ? unlinkDart.successMessage : "";
        }
        else if (unlinkWaco && unlinkWaco.success) {
            successMessage = unlinkWaco.successMessage ? unlinkWaco.successMessage : "";
        } else if (unlinkHP && unlinkHP.success) {
            successMessage = unlinkHP.successMessage ? unlinkHP.successMessage : "";
        }

        return successMessage;
    }

    onInsurancePlanChange = (value) => {
        const { dob } = this.state.fields;
        this.setState({
            selectedInsurancePlan: value, showError: false,
            fields: {
                dob: dob,
                memberId: "",
                ssn: ""
            },
            makeMemberIdEmpty: true
        });
        this.setState({ submitEnabled: false });
    }

    onKeywordSelected(val, item) {
        this.setState({ keyword: item.label }, () => {
            this.onInsurancePlanChange(val);
        });
    }

    loadKeywordTypeahead(val) {
        this.setState({ keywordItems: [], keywordLoading: true, selectedInsurancePlan: "", keyword: "" });
        const unlinkedInsurancePlans = this.getUnlinkedInsurancePlans();
        let items = unlinkedInsurancePlans.filter(option =>
            option.label && option.label.toLowerCase().includes(val.toLowerCase())
        );
        let matcheditem = unlinkedInsurancePlans.find(option =>
            option.label && option.label.toLowerCase() === val.toLowerCase()
        );

        if (matcheditem)
            this.setState({ keywordItems: items, keywordLoading: false, keywordNoResults: !(items.length > 0), selectedInsurancePlan: matcheditem.id, keyword: matcheditem.label });
        else
            this.setState({ keywordItems: items, keywordLoading: false, keywordNoResults: !(items.length > 0) });
    }


    render() {
        const { inInputMode, selectedInsurancePlan, showModal, modalText, modalYesFunction, modalNoFunction, fields, submitEnabled, showError, showToolTip, showActivePlanToolTipIndex, showInfoModal,
            keyword, keywordItems, keywordLoading, keywordNoResults } = this.state;
        const { dob, memberId, ssn } = fields;
        const { isProxyUser, aal, aalDown, swhpDown, hasHealthPlanLogin, hasFirstCare, countOfLinkAAError, linkHP, unlinkHP,
            linkAAError, linkAASuccess, isAALLinking, unLinkAAError, unLinkAASuccess, isAALUnLinking,
            linkFirstCare, unlinkFirstCare, linkDart, unlinkDart, linkWaco, unlinkWaco } = this.props;
        const unlinkedAccountsLength = this.getUnlinkedInsurancePlans().length;
        const linkedAccountsLength = this.totalHealthPlanAccounts - unlinkedAccountsLength; //aal && HealthPlanID ? 2 : aal || HealthPlanID ? 1 : 0;
        const isInProcess = (isAALLinking || isAALUnLinking) || (linkFirstCare && linkFirstCare.linking) || (unlinkFirstCare && unlinkFirstCare.unlinking) || (linkDart && linkDart.linking) || (unlinkDart && unlinkDart.unlinking) || (linkWaco && linkWaco.linking) || (unlinkWaco && unlinkWaco.unlinking) || (linkHP && linkHP.linking) || (unlinkHP && unlinkHP.unlinking);
        const unlinkSuccessMessage = this.getSuccessMessage();

        return (
            <React.Fragment>
                {isProxyUser ? null : countOfLinkAAError === 3 ? <Redirect to="/hplinkingerror" /> : <>
                    <div className="row">
                        <YesNoModal showModal={showModal} modalText={modalText} modalYesFunction={modalYesFunction} modalNoFunction={modalNoFunction} />
                        <InfoModal isOpen={showInfoModal} modalWidth="sm" modalBody={modalText} modalYesFunction={modalYesFunction} modalNoFunction={modalNoFunction} />
                        <div className="col-12 list-item-col not-linked">
                            <div className="row align-items-end">
                                <div className="col-12 col-sm-6 col-lg-3">
                                    <div className="list-item-col__label">INSURANCE & EMPLOYER <span className="label-tooltip-nowrap">PROGRAMS <span className="icon-question" id='lbl-insuranceplan' /></span>
                                        <Tooltip placement="top" isOpen={showToolTip} autohide={false} target="lbl-insuranceplan" toggle={this.toggleTooltip}>
                                            Link your insurance plan or employer program associated with Baylor Scott & White to access all features of your membership or insurance plan. This may be the name of your employer or insurance provider.
                                        </Tooltip>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-6 col-lg-4 text-left text-sm-right text-lg-left">
                                    <div className="list-item-col__info">
                                        {(aalDown && swhpDown && linkedAccountsLength === 0) ?
                                            <div className="unable-display">Unable to display</div> :
                                            <div className="list-item-col__info--unlinked">{(linkedAccountsLength === 0 ? "Not" : linkedAccountsLength) + " linked"}</div>
                                        }
                                    </div>
                                </div>
                                <div className="col-12 col-lg-5 text-sm-right">
                                    <div className="list-item-col__action">
                                        {isInProcess
                                            ? <Spinner />
                                            : <>{(!inInputMode && ((swhpDown && aalDown && unlinkedAccountsLength > 0) || (unlinkedAccountsLength === 1 && ((swhpDown && !hasHealthPlanLogin) || (aalDown && !aal)))))
                                                ? <React.Fragment>
                                                    <button id="linkbtn" type="button" className="list-item-col__action--save btn btn-link-style btn-disabled">Link Account</button>
                                                    <TryAgainToolTip target="linkbtn" />
                                                </React.Fragment>
                                                : !inInputMode && unlinkedAccountsLength !== 0 &&
                                                <button type="button" className="list-item-col__action--save btn btn-link-style" onClick={(e) => this.toggleInputMode()}>Link Account</button>
                                            }</>
                                        }
                                    </div>
                                </div>
                            </div>
                            <>{inInputMode &&
                                <div className="row edit-mode">
                                    <div className="col-12 form-group">
                                        <AutocompleteInput
                                            showDropdown
                                            value={keyword}
                                            loading={keywordLoading}
                                            placeholder="Select Insurance or Employer program"
                                            prependIcon="icon-search"
                                            itemList={keywordItems}
                                            noResults={keywordNoResults}
                                            autoHighlight={false}
                                            onChange={(e, value) => { this.loadKeywordTypeahead(value); this.setState({ keyword: value }); }}
                                            onSelect={this.onKeywordSelected}
                                        />
                                    </div>
                                    {selectedInsurancePlan ? <>
                                        <div className={`col-12 ${selectedInsurancePlan !== "aal" && selectedInsurancePlan !== "waco" && selectedInsurancePlan !== "dart" ? " col-sm-6" : null} form-group`}>
                                            <DatePicker value={this.state.fields["dob"]} name="dob"
                                                required type="text" yearsBackward={140} maxDate={new Date()}
                                                onChange={(value) => this.onDobChange(value, 'dob')}
                                            />
                                            {selectedInsurancePlan === "aal" ? <div className="col-12 dfw-separator" /> : null}
                                        </div>
                                        {selectedInsurancePlan !== "waco" && selectedInsurancePlan !== "dart" ?
                                            <div className={`col-12 ${selectedInsurancePlan === "aal" ? " col-md-5" : " col-sm-6"} form-group`}>
                                                <GenericInput placeholder="Member ID" name="memberId" id="memberId" isFieldEmpty={this.state.makeMemberIdEmpty}
                                                    value={this.state.fields['memberId']} onChange={(e) => this.handleInputChange(e)} autoComplete="new-password"
                                                />
                                            </div> : null}
                                        {selectedInsurancePlan === "aal" ?
                                            <><div className="col-12 col-md-2 col-xl-1 form-group">
                                                <div className="or-text">- OR -</div>
                                            </div>
                                                <div className="col-12 col-md-5 col-xl-6 form-group">
                                                    <SSN id="ssn" name="ssn" placeholder="Social Security Number"
                                                        ref="SocialSecurityNumber" value={this.state.fields['ssn']} onChange={(e) => this.handleInputChange(e)}
                                                    />
                                                </div></> : null
                                        }
                                    </> : null}
                                    {showError &&
                                        <div className="col-12">
                                            {selectedInsurancePlan === "aal" && inInputMode && linkAAError && <div className="error-msg" dangerouslySetInnerHTML={linkAAError} />}
                                            {!inInputMode && unLinkAAError && <div className="error-msg" dangerouslySetInnerHTML={unLinkAAError} />}
                                            {selectedInsurancePlan === "sw" && linkHP && linkHP.error && <div className="error-msg">{linkHP.error} </div>}
                                            {selectedInsurancePlan === "firstCare" && linkFirstCare && linkFirstCare.error && <div className="error-msg">{linkFirstCare.error}</div>}
                                            {selectedInsurancePlan === "dart" && linkDart && linkDart.error && <div className="error-msg">{linkDart.error}</div>}
                                            {selectedInsurancePlan === "waco" && linkWaco && linkWaco.error && <div className="error-msg">{linkWaco.error}</div>}
                                        </div>
                                    }

                                    <div className="col-12 col-lg-12 text-sm-right">
                                        <div className="list-item-col__action">
                                            <button type="button" className="list-item-col__action--btn cancel btn" onClick={(e) => this.toggleInputMode()}>Cancel</button>
                                            <button type="button" className="list-item-col__action--btn btn" disabled={!submitEnabled} onClick={(e) => this.handleLinkAccounts()}>Verify and link</button>
                                        </div>
                                    </div>

                                </div>
                            }</>

                            {unlinkFirstCare &&
                                <SuccessBanner showMessage={!this.isFromMobile && unlinkFirstCare.success}
                                    message={"We have successfully unlinked " + unlinkFirstCare.memberId + "!"}
                                />
                            }

                            <SuccessBanner showMessage={!this.isFromMobile && (unLinkAASuccess)}
                                message={unLinkAASuccess ? unLinkAASuccess : ""}
                            />

                            <SuccessBanner showMessage={!this.isFromMobile && unlinkSuccessMessage}
                                message={unlinkSuccessMessage}
                            />
                        </div>
                        <ConfirmationModal when={inInputMode && (dob !== '' || memberId !== '' || ssn !== '')} />
                    </div>
                </>}
            </React.Fragment>
        );
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        UserName: state.domain.un,
        countOfLinkAAError: state.healthPlan.countOfLinkAAError,
        isProxyUser: state.domain.ip,
        serverData: state.session.serverData,
        MobileOnQueryString: state.domain.mq,
        aalDown: state.common.aalDown,
        swhpDown: state.common.swhpDown,

        linkHP: state.healthPlan.linkHP,
        unlinkHP: state.healthPlan.unlinkHP,

        linkAAError: state.healthPlan.linkAAError,
        isAALLinking: state.healthPlan.isAALLinking,
        linkAASuccess: state.healthPlan.linkAASuccess,

        unLinkAAError: state.healthPlan.unLinkAAError,
        unLinkAASuccess: state.healthPlan.unLinkAASuccess,
        isAALUnLinking: state.healthPlan.isAALUnLinking,

        linkFirstCare: state.healthPlan.linkFirstCare,
        unlinkFirstCare: state.healthPlan.unlinkFirstCare,

        linkDart: state.healthPlan.linkDart,
        unlinkDart: state.healthPlan.unlinkDart,

        linkWaco: state.healthPlan.linkWaco,
        unlinkWaco: state.healthPlan.unlinkWaco
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        linkHealthPlanAccount: (dob, ssn, memberId, isFromMobile) => {
            memberId = (() => memberId.trim())();
            dispatch({ type: types.LINK_HEALTHPLAN_ACCOUNT, dob, ssn, memberId, isFromMobile });
        },
        clearHealthPlanLinkMessages: () => dispatch({ type: types.LINK_HEALTHPLAN_CLEAR_MESSAGE }),
        clearHealthPlanUnLinkMessages: () => dispatch({ type: types.UNLINK_HEALTHPLAN_CLEAR_MESSAGE }),
        linkAAAccount: (dob, ssn, memberId, isFromMobile) => {
            memberId = (() => memberId.trim())();
            dispatch({
                type: types.LINK_AA_ACCOUNT_START, payload: { dob: dob, ssn: ssn, memberId: memberId, isFromMobile: isFromMobile }
            })
        },
        resetCountOfLinkAAError: () => dispatch({ type: types.LINK_AA_ACCOUNT_ERROR_COUNT, countOfLinkAAError: "reset" }),
        clearAALinkMessages: () => dispatch({ type: types.LINK_AA_ACCOUNT_CLEAR_MESSAGE }),
        clearAAUnLinkMessages: () => dispatch({ type: types.UNLINK_AA_ACCOUNT_CLEAR_MESSAGE }),
        linkFirstCareAccount: (dob, memberId, isFromMobile) => {
            memberId = (() => memberId.trim())();
            dispatch({ type: types.LINK_FIRST_CARE_ACCOUNT, dob, memberId, isFromMobile })
        },

        linkDartAccount: (dob, callback) => {
            dispatch({ type: types.LINK_DART_ACCOUNT, data: { dob }, callback })
        },
        linkWacoAccount: (dob, callback) => {
            dispatch({ type: types.LINK_WACO_ACCOUNT, data: { dob }, callback })
        }

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InsurancePlan);